import React from 'react';

interface SuperuserLegacyFrameProps {
  title: string;
  legacyPath: string;
}

const SuperuserLegacyFrame: React.FC<SuperuserLegacyFrameProps> = ({ title, legacyPath }) => {
  return (
    <div className="bg-white rounded-2xl shadow-card border border-gray-100 overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-100 flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-slate-900">{title}</h1>
          <p className="text-xs text-slate-500 mt-1">Legacy view (React rewrite in progress).</p>
        </div>
        <a
          href={legacyPath}
          target="_blank"
          rel="noreferrer"
          className="text-xs font-semibold text-indigo-600 hover:text-indigo-700"
        >
          Open in new tab
        </a>
      </div>
      <div className="h-[75vh]">
        <iframe title={title} src={legacyPath} className="w-full h-full border-0" />
      </div>
    </div>
  );
};

export default SuperuserLegacyFrame;
